import { styled, Typography } from '@mui/material';
import useTranslation from 'hooks/useTranslation/useTranslation';
import React from 'react';
import ComponentWrapper from 'ui/templates/ComponentWrapper/ComponentWrapper';
import Loader from 'v2/components/Loader/Loader';

interface GradientPosition {
  bottom: number;
  right: number;
  transformOriginX: number;
  transformOriginY: number;
}

const Highlight = styled('span')(({ theme }) => ({
  color: theme.palette.primary.main
}));

const BackgroundGradient = styled('div')<GradientPosition>(
  ({ theme, bottom, right, transformOriginX, transformOriginY }) => `
  @keyframes move {
    100% {
      transform: rotate(105deg);
    }
  }

  width: 20%;
  height: 20%;
  position: fixed;
  bottom: ${bottom}%;
  right: ${right}%;
  animation: move;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-duration: 10s;
  transform-origin: ${transformOriginX}% ${transformOriginY}%;
  background: ${theme.custom.gradient.welcome};
  filter: blur(200px);
`
);

const WelcomeTextWrapper = styled('div')(`
  display: flex;
  flex-direction: row;
`);

const Welcome: React.FC<React.PropsWithChildren> = () => {
  const { translation } = useTranslation();
  return (
    <ComponentWrapper width="100vw" height="100vh" flexDirection="column" justifyContent="center" alignItems="center">
      <WelcomeTextWrapper>
        <Typography variant="h4">
          {translation.welcome_to}&nbsp;
          <Highlight>Atlas</Highlight>
        </Typography>
      </WelcomeTextWrapper>

      <BackgroundGradient bottom={30} right={0} transformOriginX={-100} transformOriginY={-100} />
      <BackgroundGradient bottom={80} right={80} transformOriginX={100} transformOriginY={100} />

      <Loader />
    </ComponentWrapper>
  );
};

export default Welcome;
